import React from 'react'
import { Redirect } from 'react-router-dom'
// import Footer from 'components/layout/Footer/index'

const PrivateRoute = ({ Component, isAuthenticated, child, isHeader, isFooter }) => {
  return isAuthenticated
    ? (
      <>
        <Component child={child} />
        {/* {isFooter ? <Footer /> : <></>} */}
      </>
      )
    : (
      <Redirect to={{ pathname: '/' }} />
      )
}

export default PrivateRoute
